import styles from './consoleTextArea.module.css';
import React from 'react';
import { ConsoleInput } from './consoleHook';

const ConsoleTextArea = () => {
    const { numKeyPresses, bind } = ConsoleInput('ccoffie@calebcoffie.com:/$', 0);
    return (
        <>
            <textarea className={styles.consoleTextArea}
                spellCheck="false"
                onChange={()=>{}}
                {...bind}
            />
            <div className={styles.promptToType} hidden={numKeyPresses > 0}>
                Begin by typing in this box
            </div>
        </>
    )
}
export default ConsoleTextArea
